import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { SettingsService } from '../settings/settings.service';
import { ChartSharedService } from '../detalle-inversion/services/chart-shared.service';
import { ChartAlVencimientoComponent } from './inversiones-vigentes/chart-al-vencimiento/chart-al-vencimiento.component';
import { CommonModule } from '@angular/common';
import { ChartRetiroHoyComponent } from './inversiones-vigentes/chart-retiro-hoy/chart-retiro-hoy.component';
import { ChartInversionComponent } from './inversiones-vigentes/chart-inversion/chart-inversion.component';
import { FormattingPipe } from './pipes/formatting.pipe';
import { CustomCurrencyPipe } from './pipes/custom-currency.pipe';
import { ObsComponent } from './obs/obs.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AccionesComponent } from './acciones/acciones.component';
import { CuentasBancariasComponent } from '../ctas-bancarias/cuentas-bancarias';

@Component({
  selector: 'app-detalle-inversion',
  standalone: true,
  imports: [
    MaterialModule,
    ChartRetiroHoyComponent,
    ChartAlVencimientoComponent,
    CommonModule,
    ChartInversionComponent,
    FormattingPipe,
    CustomCurrencyPipe,
    AccionesComponent
  ],
  templateUrl: './detalle-inversion.component.html',
  styleUrl: './detalle-inversion.component.less',
  encapsulation: ViewEncapsulation.None,
})
export class DetalleInversionComponent implements OnInit {
  displayedColumns: string[] = [
    'folio',
    'tasa',
    'capital',
    'ganancia_actual',
    'rentabilidad_hoy',
    'inversion_al_vencimiento',
    'rentabilidad_venc',
    'fecha_de_vencimiento',
    'obs',
    'acciones',
  ];
  dataSource: any = [];

  total_amount: number = 0;
  total_profit: number = 0;
  total_profit_cap: number = 0;
  total_profit_at_exp: number = 0;
  total_investment_at_exp: number = 0;
  average_rate: number = 0;
  capitalPlusInterest: any;
  profit: any;
  profitAtMaturity: any;
  rentabilidad_hoy: number = 0;
  rentabilidad_al_venc: number = 0;

  loading: boolean = true;
  hasData: boolean = false;

  tubos: any[] = [];
  selectedTuboId: number | null = null;
  selectedcompany_id: number | null = null;
  selectedTabIndex: number = 0;

  company_id: any;
  spinner = false;
  mutuoUrlStatus: { [key: number]: boolean } = {};

  constructor(
    private settings: SettingsService,
    private graphService: ChartSharedService,
    private dialog: MatDialog
  ) {}

  async ngOnInit() {
    this.resetData();

    const userId = localStorage.getItem('user_id');
    console.log("user_Id", userId)

    if (userId) {
      this.loading = true;
      await this.getTubos();
      if (this.tubos.length > 0) {
        await this.getAllDetails(parseInt(userId, 10));
      }
      this.loading = false;

    } else {
      console.log('User ID no disponible');
      this.retryGetUserId();
    }
  }

  async getTubos() {
    try {
      const bd: any = await this.settings.get_query(1, '/cliente-inversionista/tubos/');
      this.tubos = bd._body.info.tubos;
      if (this.tubos.length > 0) {
        this.selectedTuboId = this.tubos[0].tubo_id;
        this.selectedcompany_id = this.tubos[0].company_id;
      }
    } catch (error) {
      console.error('Error al obtener tubos:', error);
      this.tubos = [];
    }
  }

  company_id_account:any;
  async onTuboChange(index: number) {
    this.selectedTabIndex = index;
    this.selectedTuboId = this.tubos[index].tubo_id;
    this.selectedcompany_id = this.tubos[index].company_id;
    const userId = localStorage.getItem('user_id');
    if (userId) {
      this.loading = true;
      this.resetData();
      await this.getAllDetails(parseInt(userId, 10));
      this.loading = false;
    }
  }

  resetData() {
    this.dataSource = [];
    this.total_amount = 0;
    this.total_profit = 0;
    this.total_profit_cap = 0;
    this.total_profit_at_exp = 0;
    this.total_investment_at_exp = 0;
    this.average_rate = 0;
    this.capitalPlusInterest = null;
    this.profit = null;
    this.profitAtMaturity = null;
    this.rentabilidad_hoy = 0;
    this.rentabilidad_al_venc = 0;
    this.hasData = false;
  }

  private retryGetUserId(attempts: number = 3, delay: number = 1000) {
    if (attempts > 0) {
      setTimeout(() => {
        const userId = localStorage.getItem('user_id');
        if (userId) {
          this.getAllDetails(parseInt(userId, 10));
        } else {
          console.log(
            `Intento ${4 - attempts}: ID de usuario aún no disponible`
          );
          this.retryGetUserId(attempts - 1, delay);
        }
      }, delay);
    } else {
      console.log('Número máximo de intentos alcanzado. Recargando página.');
      window.location.reload();
    }
  }

  async getDetalleInversiones(pk: number, company_pk: any) {

    // //19742
    // pk = 19742
    try {
      let url = `/cliente-inversionista/investments/0/`;
      const params = [];
      if (this.selectedTuboId) params.push(`tubo_id=${this.selectedTuboId}`);
      if (company_pk !== null && company_pk !== undefined) params.push(`company_pk=${company_pk}`);
      if (params.length > 0) url += `?${params.join('&')}`;

      const bd: any = await this.settings.get_query(1, url);
      const body_data: any = bd._body;
      console.log('Detalle de inversiones:', body_data);


      if (body_data && body_data.info.data) {
        this.dataSource = body_data.info.data.investments_dict;
        this.calculateTotals();
        this.hasData = this.dataSource.length > 0;


      } else {
        this.hasData = false;
      }

      const fechaEmision = body_data.info.fecha_de_emision;
      const fechaVencimiento = body_data.info.fecha_de_vencimiento;
      console.log('Fecha de emisión:', fechaEmision);
      console.log('Fecha de vencimiento:', fechaVencimiento);

      this.graphService.setFechaEmision(fechaEmision);
      this.graphService.setFechaVencimiento(fechaVencimiento);

      this.graphService.setChartdetalleInversionesData(body_data);

      this.capitalPlusInterest = body_data.info.data.capital_plus_interest;
      this.profit = body_data.info.data.profit;
      this.profitAtMaturity = body_data.info.data.total_profit_at_maturity;
    } catch (error) {
      console.error('Error al obtener los datos del chart:', error);
      this.hasData = false;
    }
  }

  calculateTotals(): void {
    this.total_amount = this.dataSource.reduce(
      (total: number, element: any) => total + element.capital,
      0
    );
    this.total_profit = this.dataSource.reduce(
      (total: number, element: any) => total + element.ganancia_actual,
      0
    );
    this.total_profit_cap = this.dataSource.reduce(
      (total: number, element: any) =>
        total + (element.ganancia_actual + element.capital),
      0
    );
    this.total_profit_cap = this.dataSource.reduce(
      (total: number, element: any) =>
        total + (element.ganancia_actual + element.capital),
      0
    );
    this.total_profit_at_exp = this.dataSource.reduce(
      (total: number, element: any) => total + element.ganancia_al_vencimiento,
      0
    );
    this.total_investment_at_exp = this.dataSource.reduce(
      (total: number, element: any) => total + element.inversion_al_vencimiento,
      0
    );

    const totalRate = this.dataSource.reduce(
      (total: number, element: any) => total + parseFloat(element.tasa),
      0
    );
    this.average_rate =
      this.dataSource.length > 0 ? totalRate / this.dataSource.length : 0;

    this.dataSource.forEach((element: any) => {
      element.rentabilidad_al_venc =
        element.capital > 0
          ? (element.ganancia_al_vencimiento / element.capital) * 100
          : 0;

      element.rentabilidad_hoy =
        element.capital > 0
          ? (element.ganancia_actual / element.capital) * 100
          : 0;
    });

    const totalRentabilidadAlVenc = this.dataSource.reduce(
      (total: number, element: any) => total + element.rentabilidad_al_venc,
      0
    );
    const totalRentabilidadHoy = this.dataSource.reduce(
      (total: number, element: any) => total + element.rentabilidad_hoy,
      0
    );

    this.rentabilidad_al_venc =
      this.dataSource.length > 0
        ? totalRentabilidadAlVenc / this.dataSource.length
        : 0;
    this.rentabilidad_hoy =
      this.dataSource.length > 0
        ? totalRentabilidadHoy / this.dataSource.length
        : 0;
  }

  async getAllDetails(pk: number) {
    try {
      this.loading = true;
      this.resetData();
      localStorage.setItem('investor_pk', pk.toString());
      const [detalleInversiones] = await Promise.all([
        this.getDetalleInversiones(pk, this.company_id),
      ]);
    } catch (error) {
      console.error('Error al obtener los datos:', error);
    } finally {
      this.loading = false;
    }
  }

  openObs(folio: string, pk: string) {
    const dialogRef = this.dialog.open(ObsComponent, {
      width: '900px',
      autoFocus: false,
      data: {
        folio: folio,
        pk: pk,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('The dialog was closed');
    });
  }

  open_account(){

    console.log(this.tubos)

      let dialogRef = this.dialog.open(CuentasBancariasComponent, {
        width: '1200px',
        autoFocus: false,
      });
      dialogRef.componentInstance.id_company = this.selectedcompany_id;
      dialogRef.componentInstance.open_as_dialog = true;

      dialogRef.afterClosed().subscribe((result) => {

      });
  }

  
}
